import React from "react";
import { useTranslation } from "react-i18next";
import {
  StyledModalBody,
  StyledModal,
  ModalLogoWrapper,
  ModalLogoYET,
  ModalLogoPUB,
  ModalLogoABC,
  ModalLogoFUN,
  ModalLogoCAC,
  ModalLogoHYC,
  ModalLogoQBC,
} from "../styledComponents/StyledModals";

export const IdleTimeOutModal = ({ showModal, handleClose, skin }) => {
  const { t } = useTranslation("");

  return (
    <StyledModal isOpen={showModal}>
      <ModalLogoWrapper>
        {skin === "abc" && <ModalLogoABC />}
        {skin === "pub" && <ModalLogoPUB />}
        {skin === "yet" && <ModalLogoYET />}
        {skin === "fun" && <ModalLogoFUN />}
        {skin === "cac" && <ModalLogoCAC />}
        {skin === "hyc" && <ModalLogoHYC />}
        {skin === "qbc" && <ModalLogoQBC />}
      </ModalLogoWrapper>
      <StyledModalBody register>{t("message_idle_time_out")}</StyledModalBody>
    </StyledModal>
  );
};
